import type { jsPDF } from "jspdf";
import interBoldUrl from "../assets/fonts/inter/Inter-Bold.ttf?url";
import interRegularUrl from "../assets/fonts/inter/Inter-Regular.ttf?url";
import interSemiBoldUrl from "../assets/fonts/inter/Inter-SemiBold.ttf?url";

const fonts = [
  { file: "Inter-Regular.ttf", url: interRegularUrl, weight: 400 },
  { file: "Inter-SemiBold.ttf", url: interSemiBoldUrl, weight: 600 },
  { file: "Inter-Bold.ttf", url: interBoldUrl, weight: 700 },
] as const;

const fontData = new Map<string, Promise<string>>();

function arrayBufferToBase64(buffer: ArrayBuffer) {
  const bytes = new Uint8Array(buffer);
  const chunkSize = 0x8000;
  let binary = "";
  for (let offset = 0; offset < bytes.length; offset += chunkSize) {
    binary += String.fromCharCode(...bytes.subarray(offset, offset + chunkSize));
  }
  return window.btoa(binary);
}

function isTrueTypeFont(buffer: ArrayBuffer) {
  const signature = new Uint8Array(buffer, 0, Math.min(buffer.byteLength, 4));
  return signature.length === 4 && signature[0] === 0 && signature[1] === 1 && signature[2] === 0 && signature[3] === 0;
}

function loadFont(file: string, url: string) {
  let pending = fontData.get(file);
  if (!pending) {
    pending = fetch(url).then(async (response) => {
      if (!response.ok) throw new Error(`PDF-Schrift konnte nicht geladen werden: ${file}`);
      const buffer = await response.arrayBuffer();
      if (!isTrueTypeFont(buffer)) throw new Error(`Ungültige PDF-Schriftdatei empfangen: ${file}`);
      return arrayBufferToBase64(buffer);
    });
    fontData.set(file, pending);
  }
  return pending;
}

export async function registerC1PdfFonts(pdf: jsPDF) {
  const loaded = await Promise.all(fonts.map(async (font) => ({ ...font, data: await loadFont(font.file, font.url) })));
  loaded.forEach(({ file, weight, data }) => {
    pdf.addFileToVFS(file, data);
    pdf.addFont(file, "Inter", "normal", weight);
  });
  await Promise.all(fonts.map(({ weight }) => window.document.fonts.load(`${weight} 12px Inter`)));
}
